import React, { useEffect, useState } from 'react';
import { api } from '@unicus/react-ui-kit';

const useCostCenter = () => {
  const [enabled, setEnabled] = useState(false);
  const [uniqueCostCenter, setUniqueCostCenter] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const [allowUseResponse, uniqueCostCenterResponse] = await Promise.all([
          api.fetch('cost-centers/allow-use'),
          uniqueCostCenter === null && api.fetch('cost-centers/unique')
        ]);

        if (isMounted) {
          setEnabled(allowUseResponse?.data?.result ?? false);
          if (uniqueCostCenterResponse) {
            setUniqueCostCenter(uniqueCostCenterResponse?.data?.result ?? null);
          }
        }
      } catch (error) {
        setEnabled(false);
        setUniqueCostCenter(null);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [uniqueCostCenter]);

  return { enabledCostCenter: enabled, uniqueCostCenter };
};

export default useCostCenter;
